<template>
  <div>
    <v-stepper value>
      <v-stepper-header>
        <v-stepper-step step="1" complete>Détails préliminaires</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2" complete>Ajouter les responsables</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3" complete>Ajouter les participants</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">Notification de rappel</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <br />

    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true"
    >{{ snackbar_message }}</v-snackbar>

    <v-card class="mb-3">
      <v-card-title>
        <h6 class="primary--text">Programmer le moment d'envoi de la notification de rappel</h6>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent>
          <v-container fluid grid-list-md>
            <v-layout row wrap align-center>
              <v-flex xs5>
                <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="sendingDateMoment"
                      clearable
                      label="Date d'envoi"
                      readonly
                      v-on="on"
                      prepend-icon="mdi-calendar"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="sending_date" :min="allowedDate" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs5 offset-xs1>
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="time"
                      label="Heure d'envoi"
                      prepend-icon="mdi-timetable"
                      v-on="on"
                      solo
                      clearable
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2"
                    v-model="time"
                    format="24hr"
                    @click:minute="$refs.menu.save(time)"
                    solo
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card flat class="mb-5 mt-3">
      <v-card-text v-if="rappels.length>0">
        <h3 class="primary--text">Ancienne Notification de rappel</h3>

        <v-container grid-list-md>
          <v-layout row wrap v-for="rappel in rappels" :key="rappel.id">
            <v-flex xs2>
              <h4>Langue</h4>
              {{ rappel.language }}
            </v-flex>

            <v-flex xs3>
              <v-btn color="primary" outlined small class="a-sans-style">
                <a :href="rappel.audio_path" target="_blank">
                  <v-icon>mdi-cloud-download</v-icon>Télécharger l'audio
                </a>
              </v-btn>
            </v-flex>

            <v-flex xs2>
              <span v-if="rappel.audio_msg != 'undefined' ">
                <h4>Message audio</h4>
                {{ rappel.audio_msg }}
              </span>
            </v-flex>

            <v-flex xs2>
              <span v-if="rappel.sms != 'undefined' ">
                <h4>Message SMS</h4>
                {{ rappel.sms }}
              </span>
            </v-flex>

            <v-flex xs3>
              <span v-if="rappel.actor_contacts">
                <h4>Contacts</h4>
                {{ rappel.actor_contacts.split(',') }}
              </span>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-text v-else>
        <h3>Aucune notification de rappel précédente pour cet évènement</h3>
      </v-card-text>
    </v-card>

    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="(item, index) in liste_lang.length" :key="index">
        <v-expansion-panel-header>
          <div class="text-left">
            GROUPE DE LA LANGUE |
            <strong>{{ liste_lang[index] }}</strong> |
            <span class="ml-1">
              <strong>{{ groupe_lang[liste_lang[index]].length }}</strong> personnes
            </span>
          </div>

          <div class="text-right">
            <v-btn-toggle v-model="toggle_multiple[index]" multiple>
              <v-btn v-model="btn_audio[index]" dark color="primary">
                <v-icon color="white">mdi-microphone-outline</v-icon>
                <span>Audio</span>
              </v-btn>
              <v-btn v-model="btn_sms[index]" dark color="light-blue">
                <v-icon color="white">mdi-chat-processing</v-icon>
                <span>Message SMS</span>
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <form @submit.prevent="editEvent4" enctype="multipart/form-data">
            <div v-if="btn_audio[index]==true">
              <label>Importer le message vocal</label>
              <v-btn color="primary" outlined class="mb-3">
                <input
                  type="file"
                  @change="onImageChange"
                  accept=".wav"
                  hint="Importer le message vocal"
                />
              </v-btn>

              <v-textarea
                v-model="audio_msg[index]"
                label="Envoyer un SMS en cas d'échec de réception du message vocal"
                :rules="audioMsgRules"
                required
                solo
              ></v-textarea>
            </div>

            <div v-if="btn_sms[index]==true">
              <v-textarea v-model="sms_msg[index]" label="Ecrire un SMS à envoyer" solo></v-textarea>
            </div>
            <div v-else></div>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="text-center mt-5">
      <v-btn
        rounded
        color="info"
        @click="previousStep()"
        class="mx-3"
        :disabled="loadingUpdate"
      >Précédent</v-btn>
      <v-btn
        rounded
        color="primary"
        @click="editEvent4()"
        :loading="loadingUpdate"
        :disabled="loadingUpdate"
      >Mettre à jour</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "edit-event-4",

  data: () => ({
    panel: [0, 1, 2, 3],
    languages: [],
    groupe_lang: [],
    toggle_multiple: [],
    audio_msg: [],
    sms_msg: [],
    file_uploaded: [],
    notification: {},
    btn_audio: [],
    btn_sms: [],
    audio_path: [],
    current_index: null,
    snackbar: false,
    snackbar_message: "",
    snackbar_timeout: 5000,
    snackbar_color: "",
    edit_event: null,
    numeros: [],
    ids: [],
    is_audio_upd: [],

    loadingUpdate: false,

    sending_date: null,
    menu1: false,
    menu2: false,
    time: null,
    audioMsgRules: [v => !!v || "Message requis"]
  }),

  created() {
    this.$checkPermission('edit events')
    this.fetchUtils();
  },

  computed: {
    liste_lang() {
      let acteurs = this.$store.getters.getActorsEditableEvent;

      let groupe = acteurs.reduce((h, { id, contact, language }) => {
        return Object.assign(h, {
          [language]: (h[language] || []).concat({ id, contact })
        });
      }, {});
      this.languages = Object.getOwnPropertyNames(groupe);
      this.taille_languages = this.languages.length;

      this.groupe_lang = groupe;

      return this.languages;
    },

    rappels() {
      this.numeros = [];
      this.ids = [];
      this.is_audio_upd = [];
      this.audio_path = [];
      this.audio_msg = [];
      this.sms = [];

      let liste = this.$store.getters.getRappelNotifs;
      let numer = this.numeros;
      let id_rappels = this.ids;
      let upd = this.is_audio_upd;
      let path = this.audio_path;
      let msg = this.audio_msg;
      let message_sms = this.sms_msg;

      liste.forEach(function(item, i) {
        numer.push(item.actor_contacts);
        id_rappels.push(item.id);
        upd.push(false);
        path.push(item.audio_path);
        msg.push(item.audio_msg);
        message_sms.push(item.sms);
      });
      // this.numeros = liste.actor_contacts.split(',');
      this.numeros = numer;
      this.ids = id_rappels;
      this.is_audio_upd = upd;

      this.audio_path = path;
      this.audio_msg = msg;
      this.sms = message_sms;

      if (liste[0] != undefined) {
        this.sending_date = liste[0].sending_date;
        let heure = liste[0].sending_hour;
        let tab = heure !== null ? heure.split(":") : null;
        this.time = tab !== null ? tab[0] + ":" + tab[1] : tab;
      }

      return liste;
    },
    sendingDateMoment() {
      return this.sending_date
        ? this.$moment(this.sending_date).format("D MMMM YYYY")
        : "";
    },

    allowedDate() {
      let aujourdhui = this.$moment(new Date()).format("YYYY-MM-DD");
      return aujourdhui;
    }
  },

  methods: {
    fetchUtils() {
      let evenement = this.$store.getters.getEditableEvent;
      this.edit_event = evenement;

      this.$store.dispatch("loadRappelNotifs", evenement.id);
    },

    previousStep() {
      this.$router.push({ name: "events.edit-3" /*, params: { Pid: value }*/ });
    },

    onImageChange(e) {
      var position = this.current_index;
      let clesCreuses = Object.keys(this.btn_audio);
      for (let i = 0; i < clesCreuses.length; i++) {
        if (position != clesCreuses[i]) {
          position = clesCreuses[i];
          break;
        }
      }

      this.current_index = position;
      this.audio_path[position] = e.target.files[0];
      this.is_audio_upd[position] = true;
    },

    async editEvent4() {
      this.loadingUpdate = true;

      // Update event first
      await this.$store.dispatch("updateEvent");
      const data = this.$store.getters.getEditableEvent;
      if (data) {
        this.loadingUpdate = false;
        setTimeout(
          this.$router.push({
            name: "events.coming",
            params: { event_updated: true }
          }),
          2000
        );

        for (let i = 0; i < this.liste_lang.length; i++) {
          this.notification.new_file = false;
          this.notification.audio_path = this.audio_path[i];
          let langue = this.liste_lang[i];
          const liste = this.groupe_lang[langue];
          let contacts = "";

          liste.forEach(function(item) {
            contacts = item.contact + "," + contacts;
          });

          if (langue == null || langue == undefined) {
            langue = "Français";
          }
          this.notification.language = langue;
          this.notification.audio_msg = this.audio_msg[i];
          this.notification.sms = this.sms_msg[i];
          this.notification.actor_contacts = contacts;
          this.notification.sending_date = this.sending_date;
          this.notification.sending_hour = this.time;
          this.notification.event_id = data.id;
          this.notification.id = this.ids[i];
          // console.log(this.notification)

          if (this.is_audio_upd[i]) {
            await this.saveNotificationFile(this.audio_path[i], data.id);
            this.notification.new_file = true;
          }

          await this.updateNotifications(this.notification);
        }
      } else {
        console.log("Something went wrong!");
      }
    },

    async saveNotificationFile(file, id) {
      if (file != null) {
        const config = { headers: { "content-type": "multipart/form-data" } };
        let formData = new FormData();
        formData.append("audio_path", file);
        formData.append("event_id", id);
        try {
          await axios
            .post("/api/upload-file", formData, config)
            .then(response => {
              this.notification.audio_path = response.data;
            });
        } catch (error) {
          console.log(error);
        }
      }
    },

    async updateNotifications(notification) {
      try {
        await axios.put(
          "/api/notification_messages/" + notification.id,
          notification
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.a-sans-style a {
  text-decoration: none;
}
.theme--light.v-subheader {
  font-size: 1.3em;
  color: black;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/events/edit-4.vue